module.exports = __webpack_public_path__ + "static/media/Budget.f7ec52ac.png";